import {
  afterTakePhotoProps,
  TakePhotoPropsType,
} from '@/common/components/camera/types/hooksTypes';
import { useRef } from 'react';

const initialData = {
  currentNumber: 0,
  totalNumber: 0,
};
const useTakePhoto = ({
  videoRef,
  photoRef,
  rotate,
  onDenyCamera,
}: TakePhotoPropsType) => {
  const currentCapturingImage = useRef<{
    currentNumber: number;
    totalNumber: number;
  }>(initialData);

  const handleCreateData = ({ blob }: { blob: Blob }) => {
    const url = URL.createObjectURL(blob);
    return { blob, url };
  };

  const takePhoto = ({ afterTakePhoto }: afterTakePhotoProps) => {
    const video = videoRef.current;
    const photo = photoRef.current;

    if (!photo || !video) return;

    const ctx = photo.getContext('2d');
    if (!ctx) {
      onDenyCamera();
      return;
    }

    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;

    if (!rotate) {
      photo.width = videoWidth;
      photo.height = videoHeight;
      ctx.drawImage(video, 0, 0, videoWidth, videoHeight);
    } else {
      photo.width = videoHeight;
      photo.height = videoWidth;

      ctx.clearRect(0, 0, photo.width, photo.height);
      ctx.translate(photo.width / 2, photo.height / 2);
      ctx.rotate(-Math.PI / 2);
      ctx.drawImage(
        video,
        -videoWidth / 2,
        -videoHeight / 2,
        videoWidth,
        videoHeight,
      );
      ctx.setTransform(1, 0, 0, 1, 0, 0);
    }

    photo.toBlob(
      (blob) => {
        if (blob) {
          const images = handleCreateData({ blob });
          afterTakePhoto(images);
        }
      },
      'image/jpeg',
      0.7,
    );
  };
  const updateCurrentCapturingImage = () => {
    currentCapturingImage.current = {
      currentNumber: currentCapturingImage.current.currentNumber + 1,
      totalNumber: currentCapturingImage.current.totalNumber + 1,
    };
  };
  const resetCurrentCapturingImageNumber = () => {
    currentCapturingImage.current.currentNumber = 0;
  };
  const readonlyRef = currentCapturingImage as Readonly<
    typeof currentCapturingImage
  >;

  return {
    takePhoto,
    currentCapturingImageNumber: readonlyRef,
    updateCurrentCapturingImage,
    resetCurrentCapturingImageNumber,
  };
};

export default useTakePhoto;
